module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/faq_hairmakeup_02_sp-c5a75d9da81726300af66f1432f34d3d.png";